(() => {
  document.querySelectorAll('[data-fs-outline]').forEach(root => {
    const content = root.querySelector('[data-fs-outline-content]');
    const nav = root.querySelector('[data-fs-outline-nav]');
    const list = root.querySelector('[data-fs-outline-list]');
    if (!content || !nav || !list) return;
    const headings = [...content.querySelectorAll('h2')].filter(h => h.textContent.trim());
    if (headings.length < 3) return;
    headings.forEach((heading, index) => {
      if (!heading.id) {
        let id = `fs-content-heading-${index + 1}`;
        while (document.getElementById(id)) id += '-section';
        heading.id = id;
      }
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.textContent = heading.textContent.trim();
      link.href = `#${encodeURIComponent(heading.id)}`;
      item.append(link);
      list.append(item);
    });
    nav.hidden = false;
  });
})();
